var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInsuranceHandsHeart = function SvgInsuranceHandsHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.5v-4a1.5 1.5 0 0 1 3 0v6.556a4 4 0 0 1-.422 1.788L21 21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-2.913a2 2 0 0 1 .4-1.2l1.678-2.238a1.624 1.624 0 0 1 2.447-.173v0c.57.57.635 1.475.15 2.121L17.623 18M5 15.5v-4a1.5 1.5 0 0 0-3 0v6.556a4 4 0 0 0 .422 1.788L3 21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-2.913a2 2 0 0 0-.4-1.2l-1.678-2.238a1.624 1.624 0 0 0-2.447-.173v0a1.623 1.623 0 0 0-.15 2.121L6.377 18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.555 10.356A2.2 2.2 0 0 1 12 11v0a2.2 2.2 0 0 1-1.555-.644L7.81 7.721a2.765 2.765 0 0 1 3.911-3.911l.279.279.279-.279a2.765 2.765 0 0 1 3.911 3.911l-2.635 2.635Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgInsuranceHandsHeart;